import Phaser from 'phaser';
import { BOMB_EXPLODE_MS, TILE } from '../constants';
import type { ExplosionCell } from '../types';
export class ExplosionAnimationController {
  static register(scene: Phaser.Scene): void {
    const texture = scene.textures.get('summer');
    for (const kind of ['center', 'h', 'v', 'tip_left', 'tip_right', 'tip_up', 'tip_down']) {
      for (let i = 0; i < 6; i++) {
        const source = texture.get(`explosions/${i}`);
        // Derive individual flame arms from the original cross, never scale a cross over the map.
        const parts: Record<string, number[]> = { center: [80, 80, 64, 64], h: [36, 88, 152, 48], v: [88, 36, 48, 152], tip_left: [36, 88, 76, 48], tip_right: [112, 88, 76, 48], tip_up: [88, 36, 48, 76], tip_down: [88, 112, 48, 76] };
        const [x, y, w, h] = parts[kind];
        texture.add(`flame/${kind}/${i}`, 0, source.cutX + x, source.cutY + y, w, h);
      }
      scene.anims.create({ key: `flame:${kind}`, frames: Array.from({length:6}, (_,i)=>({key:'summer',frame:`flame/${kind}/${i}`})), duration: BOMB_EXPLODE_MS, repeat: 0 });
    }
  }
  static create(scene: Phaser.Scene, parent: Phaser.GameObjects.Container, cells: ExplosionCell[]): void {
    for (const cell of cells) {
      const x=cell.col*TILE+TILE/2, y=cell.row*TILE+TILE/2;
      const sprite=scene.add.sprite(x,y,'summer',`flame/${cell.type}/0`);
      sprite.setDisplaySize(cell.type==='v'?TILE*0.65:TILE,cell.type==='h'?TILE*0.65:TILE);
      parent.add(sprite);sprite.play(`flame:${cell.type}`);
      scene.time.delayedCall(BOMB_EXPLODE_MS,()=>sprite.destroy());
      if(cell.type==='center') {
        const smoke=scene.add.image(x,y,'summer','explosions/smoke').setScale(0.45).setAlpha(0);
        parent.add(smoke);
        scene.tweens.add({targets:smoke,alpha:{from:0.6,to:0},y:y-20,delay:BOMB_EXPLODE_MS,duration:300,onComplete:()=>smoke.destroy()});
      }
    }
  }
}
